import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import languages from "../../../../assets/json/languages.json";
import {IDsDropdownOption} from "../../../shared/components/ds-dropdown/ds-dropdown-option";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../shared/validators/DbValidators";
import {WebsiteService} from "../../../websites/website.service";
import {first} from "rxjs/operators";
import {ISubSiteData} from "./models/sub-site-data.model";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {getWebsite} from "../../../store";
import {CreateWebsiteSuccessComponent} from "../create-website-success/create-website-success.component";
import {DbModalService} from "../../../modules/modal/modal";

@Component({
    selector: 'db-create-sub-site',
    templateUrl: './create-sub-site.component.html',
    styleUrls: ['./create-sub-site.component.scss'],
    standalone: false
})
export class CreateSubSiteComponent implements OnInit {

  @Input() websiteId: number;
  @Input() isSubDomain = false;
  @Input() parentUrl = '';
  public languages: IDsDropdownOption[] = [];
  public formSubmitted = false;
  public loading = false;
  public subSiteForm = new FormGroup({
    subdomain: new FormControl('', [Validators.required, Validators.pattern(/^([a-z0-9]+(-[a-z0-9]+)*)$/)]),
    title: new FormControl('', [Validators.required, DbValidators.trimStart]),
    language: new FormControl('en_US', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)])
  });

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _modalService: DbModalService,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _websiteService: WebsiteService,
  ) { }

  ngOnInit() {
    this.resizeModal(606);
    this.mapLanguages();
  }

  public resizeModal(height): void {
    this._activeModal.resize(height, 700);
  }

  public mapLanguages(): void {
    this.languages = languages.map(({title, code}) => ({label: title, value: code}));
  }

  public addSubSite(): void {
    this.formSubmitted = true;
    if (this.subSiteForm.invalid || this.loading) return;

    this.loading = true;
    this._activeModal.hideCloseBtn(true);
    const subSiteData: Partial<ISubSiteData> = {
      ...this.subSiteForm.value,
      subdomain: this.subSiteForm.value.subdomain.toLowerCase()
    };
    this._websiteService.createSubWebsite(subSiteData, this.websiteId)
      .pipe(
        first(response => !!response, null)
      )
      .subscribe(response => {
        this.loading = false;
        this._activeModal.hideCloseBtn(false);
        if (!response.success) {
          const serverErrors = response.serverErrors ? response.serverErrors : response.response ? response.response['error'] : '';
          this.setErrors(serverErrors);
        }
        else {
          this._store.dispatch(new fromStore.LoadWebsites());
          this._activeModal.close();
          this._showCreateWebsiteSuccess(response.data.blog_id);
        }

      });
  }

  public setErrors(errors): void {
    if (!errors) return;
    if (errors.fields && errors.fields.email) {
      this.subSiteForm.get('email').setErrors({email: errors.fields.email});
    }
    if (errors.fields && errors.fields.site_title) {
      this.subSiteForm.get('email').setErrors({title: errors.fields.site_title});
    }
  }

  private _showCreateWebsiteSuccess(websiteId: number): void {
    this._store.select(getWebsite(websiteId))
      .pipe(
        first(website => !!website)
      )
      .subscribe(website => {
        this._activeModal.close();
        const modal = this._modalService.open(CreateWebsiteSuccessComponent);
        modal.componentInstance.website = website;
      });
  }
}
